// extracted by mini-css-extract-plugin
module.exports = {"button":"_GoLA70RW","buttonFake":"__iIl7ZS-","invisibleText":"_tF0OpH52"};